export default {
  id: 58,
  title: 'Target #58 - Rose',
  url: 'https://cssbattle.dev/play/58',
  colors: ['#191919', '#4F77FF', '#F9E492'],
  solution:
    '<a a><a b><a c><a d><a e><a f><style>body{background:#191919}a{position:fixed;background:#4F77FF}a[a],a[b]{background:#F9E492}a[b],a[c],a[f]{border-radius:50%}a[d],a[e],a[f]{border:10px solid #191919}a[a]{top:155;left:190;width:20;height:100;border-radius:25px}a[b]{top:145;left:180;width:40;height:40}a[c]{top:65;left:150;width:100;height:100}a[d]{top:75;left:120;border-radius:20px 20px 50px 50px;width:140;height:30}a[e]{top:55;left:140;border-radius:20px 20px 50px 50px;width:100;height:30}a[f]{top:35;left:175;width:30;height:30}</style>',
}
